import _Checkbox from "@material-ui/core/esm/Checkbox";
import React from 'react';
import cn from 'classnames';
import css from './styles.scss';
import responsiveCss from './responsive-styles.scss';
const CustomRadioButton = ({
  onClick,
  checked,
  className,
  isResponsive = false
}) => {
  const styles = isResponsive ? responsiveCss : css;
  return /*#__PURE__*/React.createElement(_Checkbox, {
    onClick: onClick,
    checked: checked,
    className: cn(styles.radioButton, className),
    icon: /*#__PURE__*/React.createElement("span", {
      className: styles.radioBtnUnchecked
    }),
    checkedIcon: /*#__PURE__*/React.createElement("span", {
      className: styles.radioBtnChecked
    })
  });
};
export default CustomRadioButton;